import { cn } from '@/lib/utils';
import { RitualIcon } from '@/components/ui/RitualIcon';

interface AgentAvatarProps {
  size?: 'sm' | 'md' | 'lg';
  isThinking?: boolean;
  className?: string;
}

const sizeClasses = {
  sm: 'w-8 h-8',
  md: 'w-12 h-12',
  lg: 'w-16 h-16',
};

const iconSizes = {
  sm: 'sm' as const,
  md: 'md' as const,
  lg: 'lg' as const,
};

export function AgentAvatar({ size = 'md', isThinking = false, className }: AgentAvatarProps) {
  return (
    <div
      className={cn(
        'relative rounded-full flex items-center justify-center',
        'bg-gradient-to-br from-primary via-primary to-secondary',
        'shadow-lg shadow-primary/25',
        sizeClasses[size],
        isThinking && 'animate-pulse',
        className
      )}
    >
      {/* Glow effect */}
      <div 
        className={cn(
          'absolute inset-0 rounded-full bg-primary/20 blur-xl',
          isThinking && 'animate-ping'
        )} 
      />
      
      {/* Icon */}
      <RitualIcon 
        size={iconSizes[size]}
        className={cn(
          'relative z-10',
          isThinking && 'animate-spin-slow'
        )} 
      />

      {/* Status indicator */}
      <div 
        className={cn(
          'absolute -bottom-0.5 -right-0.5 w-3 h-3 rounded-full border-2 border-background',
          isThinking ? 'bg-secondary animate-pulse' : 'bg-success'
        )}
      />
    </div>
  );
}
